// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__27oRQ","form":"styles_form__1Gk4E"};